module.exports = __webpack_public_path__ + "img/priest_f.235263b5.png";